<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/LKPublications/formdata/table-headers-revisions'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationFormdataRevisions',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
